/* eslint-disable id-length */
import _isNaN from 'lodash/isNaN';
import { add, rot, mid } from './util';
import validateLength from './validation';
import assetsPath from '../util/assetsPath';

const icon = `${assetsPath}/shapes/icons/icon_U-Shape.svg`;
const labeledIcon = `${assetsPath}/shapes/labeledIcons/icon_U-Shape.svg`;

const uShape = {
  label: 'U Shape',
  icon,
  labeledIcon,
  edges: [
    {
      key: 'a',
      shortLabel: 'A',
      longLabel: 'Side A',
      minLength: 1,
      maxLength: 999,
    },
    {
      key: 'b',
      shortLabel: 'B',
      longLabel: 'Side B',
      minLength: 1,
      maxLength: 999,
    },
    {
      key: 'c',
      shortLabel: 'C',
      longLabel: 'Side C',
      minLength: 1,
      maxLength: 999,
    },
    {
      key: 'd',
      shortLabel: 'D',
      longLabel: 'Side D',
      minLength: 1,
      maxLength: 999,
    },
    {
      key: 'e',
      shortLabel: 'E',
      longLabel: 'Side E',
      minLength: 1,
      maxLength: 999,
    },
    {
      key: 'f',
      shortLabel: 'F',
      longLabel: 'Side F',
      minLength: 1,
      maxLength: 999,
      canEditFinish: false,
    },
  ],
  defaults: {
    edges: {
      a: {
        length: 26, isAgainstWall: false, hasBacksplash: false, backsplashHeight: '',
      },
      b: {
        length: 60, isAgainstWall: false, hasBacksplash: false, backsplashHeight: '',
      },
      c: {
        length: 84, isAgainstWall: false, hasBacksplash: false, backsplashHeight: '',
      },
      d: {
        length: 48, isAgainstWall: false, hasBacksplash: false, backsplashHeight: '',
      },
      e: {
        length: 26, isAgainstWall: false, hasBacksplash: false, backsplashHeight: '',
      },
      f: {
        length: 24, isAgainstWall: false, hasBacksplash: false, backsplashHeight: '',
      },
    },
    rotation: 180,
  },
  toPolygon: ({
    edges: {
      a, b, c, d, e, f,
    }, position, rotation,
  }) => {
    const poly = [
      { x: +a.length, y: 0 },
      { x: 0, y: 0 },
      { x: 0, y: +b.length },
      { x: +c.length, y: +b.length },
      { x: +c.length, y: +b.length - +d.length },
      { x: +c.length - +e.length, y: +b.length - +d.length },
      { x: +c.length - +e.length, y: +b.length - (+d.length - +f.length) },
      { x: +a.length, y: +b.length - (+d.length - +f.length) },
    ];
    return add(rot(poly, (-rotation * Math.PI) / 180, mid(poly)), position);
  },
  validate: ({ edges }) => {
    const errors = {
      a: [],
      b: [],
      c: [],
      d: [],
      e: [],
      f: [],
    };

    // Validate Lengths
    uShape.edges.forEach((e) => {
      const edge = edges[e.key];
      if (edge) {
        const lengthValidation = validateLength(edge.length, e.minLength, e.maxLength);
        if (lengthValidation) {
          errors[e.key].push(lengthValidation);
        }
        if (edge.hasBacksplash) {
          if (_isNaN(edge.backsplashHeight)) {
            errors[e.key].push('Backsplash Height is not valid');
          } else if (edge.backsplashHeight < 0) {
            errors[e.key].push('Backsplash Height cannot be negative');
          }
        }
        if (e.key === 'd') {
          const edgeF = edges.f;
          if (Number(edge.length) <= Number(edgeF.length)) {
            errors[e.key].push('Length should be greater than F');
            errors.f.push('Length should be less than D');
          }
        }
        if (e.key === 'c') {
          const edgeE = edges.e;
          const edgeA = edges.a;
          if (Number(edge.length) <= (Number(edgeE.length) + Number(edgeA.length))) {
            errors[e.key].push(`Length should be greater than ${Number(edgeA.length) + Number(edgeE.length)} (A + E)`);
          }
        }
      }
    });

    errors.messages = Object.keys(errors).map((edge) => {
      if (errors[edge].length) {
        const edgeMeta = uShape.edges.find((e) => e.key === edge);
        const message = errors[edge].join('. ');
        return { edge: edgeMeta.longLabel, message: `${message}.` };
      }
      return null;
    }).filter((x) => x);
    errors.isValid = !(errors.messages.length);
    return errors;
  },
};

export default uShape;
